import { APIRoute } from '@/modules/utils'

export const GetRoute: APIRoute = {
  method: 'GET',
  path: `/v2/customer/:insuranceId/attempt`,
}

export type GetUrlParams = {
  insuranceId: string
}

export type GetResponse = { attempt: number }

export const DecrementRoute: APIRoute = {
  method: 'GET',
  path: `/v2/customer/:insuranceId/attempt/decrement`,
}

export type DecrementUrlParams = {
  insuranceId: string
}

export type DecrementResponse = { attempt: number }
